<template>
<v-app>
  <main>
    <v-content>
      <!-- <v-container fluid="fluid"> -->

      <v-container>
        <v-row>
          <!-- <div style="position: relative; top: 50%; transform: translateY(50%);">ciao</div> -->
          <!-- <v-col md3="md3"></v-col> -->
          <v-col md6="md6" xs12="xs12" style="margin: 10rem auto;">
            <div class="display-3 mb-5">{{welcome}}</div>

            <transition name="fade">
              <div v-if="error.show">
                <v-alert error v-bind:value="true" class="mb-5">{{error.message}}</v-alert>
              </div>
            </transition>

            <v-text-field @keyup.enter.native="logIn" v-model="email" label="Email"></v-text-field>
            <v-text-field @keyup.enter.native="logIn" v-model="passw" label="Password" type="password"></v-text-field>
            <div class="text-xs-center">
              <v-btn @click.native="logIn" primary>Login</v-btn>
              <p class="mt-3">Non hai ancora un account? <router-link :to="{name: 'Signup'}">Iscriviti</router-link></p>
              <!-- <v-btn @click.native="signUp">Sign up</v-btn> -->
              <!-- <v-btn @click.native="logOut" error>Logout</v-btn> -->
            </div>

          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </main>
</v-app>
</template>

<script>

// Firebase
import firebase from '../modules/firebase'
// Store
import store from '../modules/store'

export default {
  data () {
    return {
      store,
      email: '',
      passw: '',
      error: {
        show: false,
        message: ''
      },
      welcome: 'Welcome back!'
    }
  },
  methods: {
    logIn: function () {
      firebase.auth().signInWithEmailAndPassword(this.email, this.passw)
      .then(m => {
        this.error.show = false
        this.$router.push({name: 'Main'})
      })
      .catch(e => {
        this.error.show = true
        this.error.message = e.message
        setTimeout(() => { this.error.show = false }, 3000)
      })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
opacity: 0
}
</style>



// WEBPACK FOOTER //
// Login.vue?36403d36